const effectIcons: Record<string, string> = {
  "corrosive shell": "corrosion",
  "drag drives": "engine-disruption",
  "drag munitions": "engine-disruption",
  "drive distributors": "engine-disruption",
  "fsd interrupt": "fsd-reboot",
  "mass lock munition": "mass-locked",
  "emissive munitions": "increased-emissions",
  "radiant canister": "increased-emissions",
  "regeneration sequence": "regeneration",
  "concordant sequence": "regeneration",
  "fast charge": "regeneration",
  "scramble spectrum": "malfunction",
  "ion disruptor": "malfunction",
  "dazzle shell": "sensor-disruption",
  "dispersal field": "sensor-disruption",
  "feedback cascade": "shield-cell-cascade",
  "feedback cascade (legacy)": "shield-cell-cascade",
  "reverberating cascade": "shield-generator-attack",
  "target lock breaker": "target-interference",
  "overload munitions": "targeting-overload",
  "thermal cascade": "thermal-attack",
  "thermal shock": "thermal-attack",
  "thermal vent": "thermal-attack",
  "thermal conduit": "thermal-attack",
  "thermal spread": "thermal-attack",
  "high yield shell": "hull-breach",
  "penetrator munitions": "internal-damage",
  "penetrator payload": "internal-damage",
  "super penetrator": "internal-damage",
  "super penetrator (legacy)": "internal-damage",
  "phasing sequence": "shield-breach",
  "inertial impact": "impulse-attack",
  "force shell": "impulse-attack",
};

export function engineerEffectIconFor(effectName: string | null | undefined): string | null {
  if (!effectName) return null;
  const icon = effectIcons[effectName.trim().toLowerCase()];
  return icon ? `/engineer-effects/${icon}.svg` : null;
}
